import H from 'constants/httpMethod.const';
import UMSG_TYPE from 'constants/umsg/type.const';
import logger from 'utils/logger.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

const L = logger('beSalonPin'); // eslint-disable-line no-unused-vars

const fromDtoToPin = (dto) => ({
  enabledPinForAll: dto?.results?.enable_pin_for_all,
  stylistsWithEmail: dto?.results?.stylists_with_email,
  stylistsWithoutEmail: dto?.results?.stylists_without_email,
});

export const ibeTogglePinRead = actionEndpointBe(
  'ibeTogglePinRead',
  H.get,
  'settings/v2/toggle/salon/stylists/pin/:salonId/',
  (options) => ({
    ...options,
    inert: true,
    umsg: UMSG_TYPE.global,
    fromDto: fromDtoToPin,
  }),
);

//
const fromPinToDto = (item) => ({
  enable_pin_for_all: item?.enabledPinForAll,
  stylists_with_email: item?.stylistsWithEmail,
  stylists_without_email: item?.stylistsWithoutEmail,
});

export const ibeTogglePinSend = actionEndpointBe(
  'ibeTogglePinSend',
  H.post,
  'settings/v2/toggle/salon/stylists/pin/:salonId/',
  (options, extra) => ({
    ...options,
    inert: true,
    isMissingParams: false,
    data: extra?.data,
    umsg: UMSG_TYPE.global,
    toDto: fromPinToDto,
  }),
);
